import * as ActionTypes from './actionTypes'
import {createAction} from 'redux-actions'

const setSelectedTab = createAction(ActionTypes.SELECTED_TAB_SET)

export const changeTab = (tab) => (dispatch) => {
    dispatch(setSelectedTab(tab))
}



// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/actions.js